import React, { useRef } from 'react';
import {
	Button,
	Div,
	InputGroup,
	Typography,
} from '@icecreamsocial/components';
import { CopyIcon } from '../SupportedIcons';
import { useIntl } from 'react-intl';

export const OfferCode = ({ code, label, onCopy = () => null, ...rest }) => {
	const OVERFLOW_STYLES = { whiteSpace: 'nowrap', textOverflow: 'ellipsis' };
	const codeRef = useRef(null);
	const intl = useIntl();

	/**
	 * localization
	 */
	const COPY = intl.formatMessage({
		id: 'incentive.discountCode.copy',
		defaultMessage: 'Copy',
		description: 'Call to action text to copy a code',
	});

	/**
	 * simple memoized implementation of copying based on https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
	 * @param {function} onCopy callback once copy is called
	 */
	const copy = () => {
		codeRef.current.select();
		codeRef.current.setSelectionRange(0, 99999); // for mobile

		document.execCommand('copy');
		onCopy(codeRef.current.value);
	};

	return (
		<Div display='flex' alignItems='center' style={{ gap: '8px' }} {...rest}>
			<InputGroup display='block' elWidth='100%' {...rest}>
				<InputGroup.Fields backgroundColor='ambient' padding='sm' border='none'>
					<InputGroup.Input
						ref={codeRef}
						value={code}
						marginLeft='sm'
						textDecoration='underline'
						elWidth='100%'
						overflow='hidden'
						style={OVERFLOW_STYLES}
						readOnly
					/>

					<Button
						type='button'
						display='flex'
						alignItems='center'
						backgroundColor={['transparent', 'transparent', 'accent']}
						textColor={['accent', 'accent', 'bodyInverse']}
						borderRadius={['40px', '40px', '32px']}
						paddingLeft={['md']}
						paddingRight={['md']}
						shadow='none'
						style={{ gap: '8px' }}
						onClick={copy}
					>
						<CopyIcon size={18} />
						<Typography.Span
							display={[
								navigator.share ? 'none' : 'block',
								navigator.share ? 'none' : 'block',
								'inline',
							]}
						>
							{COPY}
						</Typography.Span>
					</Button>
				</InputGroup.Fields>
				{label && <InputGroup.Label typoSize='.8em'>{label}</InputGroup.Label>}
			</InputGroup>
		</Div>
	);
};
